import _ from 'lodash';
import escapeHtml from 'escape-html';
import { Text } from 'slate';

import hasPluginOfType from './has_plugin_of_type';
import serializeHtmlText from './serialize_html_text';

// Serializes everything, including variables and placeholders. Used esp. for saving editor content to
// the backend. Shouldn't end up in customer stuff.
export default function serializeHtml(editor) {
  return serializeNode(editor, editor);
}

function serializeNode(editor, node) {
  if (Text.isText(node)) {
    return serializeHtmlText(node);
  }

  const children = node.children.map(n => serializeNode(editor, n)).join('');

  switch (node.type) {
    case 'variable':
      return `<variable ${createAttributesString(node.attributes)}>${children}</variable>`;
    case 'placeholder':
      return `<placeholder>${children}</placeholder>`;
    case 'p': {
      if (children === '') {
        return `<div><br></div>`;
      }
      return `<div>${children}</div>`;
    }
    case 'a': {
      if (!hasPluginOfType(editor, 'a')) {
        return children;
      }
      return `<a href="${node.url}" target="_blank" rel="noopener noreferrer">${children}</a>`;
    }
    default:
      return children;
  }
}

function createAttributesString(attrs) {
  const strings = [];
  _.forEach(attrs, (value, key) => {
    if (value != null) {
      strings.push(`${key}="${escapeHtml(value)}"`);
    }
  });
  return strings.join(' ');
}
